export var SnapshotEventType;
(function (SnapshotEventType) {
    SnapshotEventType["Created"] = "created";
    SnapshotEventType["Updated"] = "updated";
    SnapshotEventType["Deleted"] = "deleted";
    SnapshotEventType["Fetched"] = "fetched";
})(SnapshotEventType || (SnapshotEventType = {}));
//# sourceMappingURL=snapshot-event.js.map